import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "./context/AuthContext";

const PrivateRoute = () => {
  const { user } = useContext(AuthContext);

  // Not logged in → redirect
  if (!user) {
    return <Navigate to="/user-login" replace />;
  }

  // Logged in → allow route
  return <Outlet />;
};

export default PrivateRoute;
